import { titleFromStack } from './utils';
import styles from './stacked-cell.module.scss';

// ─────────────────────────────────────
// Props
// ─────────────────────────────────────

interface StackedCellProps {
  values: string[];
  align: 'left' | 'center' | 'right';
}

/**
 * Renders a multi-value cell as one line per value.
 * @param {StackedCellProps} props - Component props
 * @return {JSX.Element} The stacked values
 */
export function StackedCell({ values, align }: StackedCellProps) {
  return (
    <div
      role="list"
      className={styles.stackedCell}
      style={{ textAlign: align }}
      onMouseEnter={titleFromStack}
    >
      {values.map((value, i) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key -- index, not value: a cell can hold the same value twice.
        <div key={i} role="listitem">
          {value}
        </div>
      ))}
    </div>
  );
}
